import * as XLSX from 'xlsx';
import i18n from '../i18n';

function num(n) {
    return Number(n ?? 0);
}

function fmtRub(n) {
    return num(n);
}

/**
 * @param {object} data — ответ GET /event/finance/export-details
 */
export function downloadEventFinanceExcel(data) {
    if (!data || !data.summary) return;

    const wb = XLSX.utils.book_new();
    const school = data.schoolName || '';
    const s = data.summary;

    const summaryAoA = [
        [i18n.t('eventFinance:title')],
        [school],
        [i18n.t('eventFinance:generated', { date: data.generatedAt || '' })],
        [],
        [i18n.t('eventFinance:metric'), i18n.t('eventFinance:valueRub')],
        [i18n.t('eventFinance:eventsCount'), s.eventsCount],
        [i18n.t('eventFinance:participantsRows'), s.participantsCount],
        [i18n.t('eventFinance:commonCosts'), fmtRub(s.commonCostsTotal)],
        [i18n.t('eventFinance:personalCosts'), fmtRub(s.participantsCostsTotal)],
        [i18n.t('eventFinance:grandTotal'), fmtRub(s.grandTotal)],
    ];
    const wsSum = XLSX.utils.aoa_to_sheet(summaryAoA);
    wsSum['!cols'] = [{ wch: 48 }, { wch: 18 }];
    XLSX.utils.book_append_sheet(wb, wsSum, i18n.t('eventFinance:sheetSummary'));

    const eventHeader = [
        i18n.t('eventFinance:colName'),
        i18n.t('eventFinance:colDate'),
        i18n.t('eventFinance:colCity'),
        i18n.t('eventFinance:colCommonTicket'),
        i18n.t('eventFinance:colCommonTransfer'),
        i18n.t('eventFinance:colCommonHotel'),
        i18n.t('eventFinance:colCommonOther'),
        i18n.t('eventFinance:colCommonSum'),
        i18n.t('eventFinance:colParticipants'),
        i18n.t('eventFinance:colPersonalSum'),
        i18n.t('eventFinance:colEventTotal')
    ];
    const eventRows = (data.events || []).map(ev => {
        const c = ev.commonCosts || {};
        return [
            ev.title,
            ev.startDate,
            ev.city || '',
            fmtRub(c.ticket),
            fmtRub(c.transfer),
            fmtRub(c.hotel),
            fmtRub(c.other),
            fmtRub(c.total),
            ev.participantsCount,
            fmtRub(ev.participantsCostsSum),
            fmtRub(ev.eventGrandTotal)
        ];
    });
    const wsEv = XLSX.utils.aoa_to_sheet([eventHeader, ...eventRows]);
    wsEv['!cols'] = eventHeader.map(() => ({ wch: 14 }));
    wsEv['!cols'][0] = { wch: 32 };
    XLSX.utils.book_append_sheet(wb, wsEv, i18n.t('eventFinance:sheetEvents'));

    const partHeader = [
        i18n.t('eventFinance:colEvent'),
        i18n.t('eventFinance:colDate'),
        i18n.t('eventFinance:colFullName'),
        i18n.t('eventFinance:colRole'),
        i18n.t('eventFinance:colTicket'),
        i18n.t('eventFinance:colTransfer'),
        i18n.t('eventFinance:colHotel'),
        i18n.t('eventFinance:colOther'),
        i18n.t('eventFinance:colPersonTotal'),
        i18n.t('eventFinance:colNote')
    ];
    const partRows = [];
    for (const ev of data.events || []) {
        for (const p of ev.participants || []) {
            partRows.push([
                ev.title,
                ev.startDate,
                p.fullName,
                p.roleLabel || p.role,
                fmtRub(p.ticketCost),
                fmtRub(p.transferCost),
                fmtRub(p.hotelCost),
                fmtRub(p.otherCost),
                fmtRub(p.personTotal ?? p.PersonTotal),
                p.note || ''
            ]);
        }
    }
    const wsP = XLSX.utils.aoa_to_sheet([partHeader, ...partRows]);
    wsP['!cols'] = [{ wch: 28 }, { wch: 12 }, { wch: 26 }, { wch: 18 }, ...Array(7).fill({ wch: 14 })];
    XLSX.utils.book_append_sheet(wb, wsP, i18n.t('eventFinance:sheetParticipants'));

    const stamp = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `meropriyatiya_finansy_${stamp}.xlsx`);
}
